import React from 'react';
import './Features.css';

const Features: React.FC = () => {
    const features = [
        {
            title: "Customizable Summary Period",
            description: "Choose how many past days to include in your summary, tailored to your workflow.",
            icon: "🗓️"
        },
        {
            title: "Automated Daily Digest",
            description: "Receive a comprehensive summary of your inbox, sent directly from your account.",
            icon: "📨"
        },
        {
            title: "Smart Categorization",
            description: "Emails automatically sorted into categories like Follow-ups, Payment Reminders, and more.",
            icon: "🏷️"
        },
        {
            title: "Organized Layout",
            description: "Clear, table-like format makes it easy to scan and understand your email summary.",
            icon: "📊"
        },
        {
            title: "Sender Exclusion",
            description: "Customize your summary by excluding specific senders or email patterns.",
            icon: "🎯"
        },
        {
            title: "Zero Configuration",
            description: "Works instantly with your Gmail account, no complex setup required.",
            icon: "⚡"
        }
    ];

    return (
        <section className="features" id="features">
            <div className="container">
                <h2>Powerful Features</h2>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-card animate-fadeIn animate-delay-1">
                            <div className="feature-icon">{feature.icon}</div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;